<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12 md6 offset-md3>
        <file
          v-for="(file, i) in files"
          :key="i"
          :file="file"
        ></file>
      </v-flex>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="fileDialog" persistent max-width="300">
        <v-card>
          <v-card-title class="headline">{{fileTitle}}</v-card-title>
          <v-card-text>
            <p>Upload this file? </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" flat @click="fileDialog = false" :disabled="loading">Close</v-btn>
            <v-btn 
              dark
              color="blue darken-1" 
              :loading="loading"
              :disabled="loading"
              @click="uploadFile"
            >
              Upload
              <v-icon right dark>cloud_upload</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-tooltip left lazy>
      <v-btn
        slot="activator"
        fixed
        bottom
        right
        fab
        color="red darken-1"
        dark
        style="cursor: pointer;"
        tag="label"
        for="file-upload-instructor"
      >
        <v-icon>attach_file</v-icon>
      </v-btn>
      <input hidden ref="file" @change="fileHandler" type="file" id="file-upload-instructor">
      <span>Upload file</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import axios from 'axios'
import File from './File.vue'
export default {
  components: {
    File
  },
  props: ['files'],
  data(){
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      file: null,
      fileTitle: '',
      fileDialog: false,
      fileName: '',
      loading: false
    }
  },
  created(){
    
  },
  methods: {
    fileHandler(){
      this.file = this.$refs.file.files[0]
      this.fileTitle = this.$refs.file.files[0].name  
      this.fileDialog = true
    },  
    async uploadFile(){
      try{
        this.loading = true
        const data = new FormData()
        data.append('file_name', this.fileTitle)
        data.append('file', this.file)
        let res = await axios.post(`/api/class/${this.$route.params.id}/upload`, data, { 
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`,
            'Content-Type': 'multipart/form-data'
          }
        })
        this.$store.dispatch('instructor/FETCH_FILES', {class_id: this.$route.params.id})
        this.file = null
        this.fileTitle = ''
        this.loading = false
        this.fileDialog = false
      }catch(e){
        console.log(e)
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Instructor/Classroom/Files.vue